export const PRODUCT_TYPES = {
  Unknown: 0,
  Node: 1,
  Virtual: 2,
  PhysicalSimple: 3,
  PhysicalVariant: 4,
  NftDigital: 5,
  BlockchainAsset: 6,
};

export const isBlockchainAsset = (productTypeId) =>
  productTypeId === PRODUCT_TYPES.BlockchainAsset ||
  productTypeId === PRODUCT_TYPES.NftDigital;
